import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS,
} from '@modules/affiliate-program-subaffiliate-deals/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_DELETE_MUTATION_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_DELETE_URL,
} from '../constants';

export default function useAffiliateProgramSubAffiliateDealDeleteMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_DELETE_MUTATION_KEY],
    mutationFn: (id) => fetchDelete<void>(
      AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_DELETE_URL,
      {
        permission: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS.DELETE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY] });

      displayPresetToast('removed');
    },
  });
}
